module.exports = __webpack_public_path__ + "media/images/bullet-8ad8899d89060b11f02890e95c1c16e4.svg";